<form>
  <p class="field-dialog__content__scroll__title">
    {{ 'GROUPS.DIALOG.TABS.USERS.LINKED.TITLE' | translate }} ({{ page?.totalCount || 0 }})
  </p>

  <div class="tab-users__body">
    <p *ngIf="!page?.totalCount" class="tab-users__body__not-found-title">
      {{
        (searchInputValue.value
          ? 'GROUPS.DIALOG.TABS.USERS.LINK.NOT_FOUND'
          : 'GROUPS.DIALOG.TABS.USERS.LINKED.NOT_FOUND'
        ) | translate
      }}
    </p>

    <ng-container *ngIf="page?.items.length">
      <div
        class="card tab-users__body__card"
        *ngFor="let linkedUser of page.items"
        fxLayout="row"
        fxLayout="space-between center"
        fxLayoutGap="16px"
      >
        <img
          class="tab-users__body__card__avatar"
          [alt]="linkedUser.name"
          [src]="linkedUser.avatarUrl || 'https://ui-avatars.com/api/?name=' + linkedUser.name"
        />

        <div fxLayout="column" fxLayoutAlign="center start" fxFlex>
          <p
            *ngIf="!linkedUser.archived"
            class="tab-users__body__card__name"
            [matTooltip]="linkedUser.name"
            matTooltipPosition="above"
          >
            {{ linkedUser.name }}
          </p>

          <p *ngIf="linkedUser.archived" class="tab-users__body__card__archived-name">
            <span [matTooltip]="linkedUser.name" matTooltipPosition="above">{{ linkedUser.name }}</span>
            <span>({{ 'GROUPS.DIALOG.TABS.USERS.LINKED.ARCHIVED' | translate }})</span>
          </p>

          <p class="tab-users__body__card__email">
            {{ linkedUser.email }}
          </p>
        </div>

        <div *ngIf="!isViewMode">
          <button
            [disabled]="isLoading"
            (click)="unlinkUser(linkedUser.id)"
            class="tab-users__body__card__remove"
            [matTooltip]="'GROUPS.DIALOG.TABS.USERS.LINKED.UNLINK' | translate"
            matTooltipPosition="left"
            mat-icon-button
          >
            <i class="angularjs-fuse-icon icon-account-minus"></i>
          </button>
        </div>
      </div>

      <div class="tab-users__paginator-wrapper">
        <fc-paginator
          class="tab-users__paginator"
          #paginator
          [pageSize]="pageSize"
          [totalCount]="page?.totalCount"
          [currentPageLength]="page?.items.length"
          [isLoading]="isPageChanging"
          (page)="onPageChange($event)"
        ></fc-paginator>
      </div>
    </ng-container>
  </div>
</form>
